import { Injectable } from '@angular/core';
import { StoreConfig, Store } from '@datorama/akita';
import { LeaderboardEntry } from './leaderboard.model';

export interface LeaderboardState {
  leaderboard: LeaderboardEntry[];
  monthlyLeaderboard: LeaderboardEntry[];
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'leaderboard' })
export class LeaderboardStore extends Store<LeaderboardState> {
  // todo: when multiple leaderboards are implemented, make this an entity store that stores objects in this shape:
  // { date: Date, leaderboard: LeaderboardEntry[] }
  // keyed on date.
  constructor() {
    super({});
  }
}
